import axios from "axios";
import { Urls } from "../../../store/urls";

export const getFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CUT_OFF_FILTER_API,
        params: params,
    });
};

export const getListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.CUT_OFF_LIST_API,
        params: params,
    });
};

export const getDetailRepo = (id) => {
    return axios({
        method: "GET",
        url: Urls.CUT_OFF_LIST_API + '/' + id,
    });
};

export const PostDetailRepo = (params) => {
    return axios({
        method: "POST",
        url: Urls.CUT_OFF_LIST_API,
        data: params,
    });
};

export const putDetailRepo = (params, id) => {
    return axios({
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        data: params,
        url: Urls.CUT_OFF_LIST_API + '/' + id
    });
};